import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';

function APFCPannel() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="apfc-panel">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">⚡ APFC Panel (Automatic Power Factor Correction)</h2>
              <p className="text-muted">
                Smart reactive power control for optimized energy efficiency and system protection.
              </p>
              <p className="text-muted fw-semibold">APFC Panel &nbsp; | &nbsp; Electric Low Voltage Panel</p>
            </div>

            {/* Application */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                APFC panels are used to automatically maintain and improve the power factor of electrical systems by switching capacitor banks on and off. They are widely used in industries, commercial buildings, hospitals, shopping complexes, and manufacturing units to reduce power losses and avoid penalties from utility providers.
              </p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src="https://neptuneindia.com/wp-content/uploads/apfc-panels.png"
                  alt="APFC Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src="https://neptuneindia.com/wp-content/uploads/JOB-NO-1524-C2.jpg"
                  alt="Automatic Power Factor Correction Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 415V, 3-phase, 50Hz</li>
                <li><strong>Capacitor Bank Rating:</strong> 20 kVAR to 1000 kVAR (expandable)</li>
                <li><strong>Steps:</strong> 6 to 16 (or as required)</li>
                <li><strong>Controller:</strong> Microprocessor-based intelligent relay</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 61439-1 & 2</strong> – LV switchgear assemblies</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Automatic switching of capacitor banks based on load conditions</li>
                <li>Improves power factor to avoid utility penalties and reduce energy costs</li>
                <li>Digital power factor controller with display and alarms</li>
                <li>Stepwise control with detuned/reactor options for harmonic-rich environments</li>
                <li>Over-voltage, under-voltage, and over-temperature protection</li>
                <li>Modular design with easy maintenance and future expansion</li>
                <li>Remote monitoring capability (optional via IoT/SCADA)</li>
              </ul>
            </div>

            {/* Types */}
            <div className="mb-4 p-4 bg-white border-start border-4 border-success rounded" data-aos="fade-up">
              <h5 className="text-success fw-semibold">Types of APFC Panels</h5>
              <ul className="text-muted mb-0">
                <li><strong>Fixed Capacitor Panels:</strong> Predefined capacitor setup that doesn’t adjust with load changes.</li>
                <li><strong>Automatic Capacitor Panels:</strong> Smart adjustment of capacitor count based on real-time demand.</li>
              </ul>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default APFCPannel;
